import React from "react";
import {Modal} from "antd";
import CalculatedTransferMapTab from "../calculatedTransferMapTab/CalculatedTransferMapTab";

const MapPopup = ({encodedPolylines, onClose}) => {
    return (
        <Modal
            title="Harita Görünümü"
            visible={true}
            onCancel={onClose}
            footer={null}
            width="90%"
            style={{top: 20}}
            bodyStyle={{height: "80vh", padding: "24px"}}
        >
            <CalculatedTransferMapTab encodedPolylines={encodedPolylines} />
        </Modal>
    );
};

export default MapPopup;
